import * as React from "react";

interface IProps {
    policyStartDate: string;
}

export class FutureCoverBanner extends React.Component<IProps, {}> {

    public render() {
        return (
            <div className="plugin-panel inner-content mb-3 banner banner-info">
                Heads up – your cover begins on ({this.props.policyStartDate}), unfortunately we are unable to
                process a claim prior to your start date because you're not covered
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/renters/rentersClaims/FutureCoverBanner.tsx